import styled, { css, CSSProp } from "styled-components"
import { themeGet } from "@styled-system/theme-get"

import { elementCss, ElementProps } from "legacy/components/shared/base/Element"
import { ThemeProps } from "src/legacy/theme"

export type Variant =
  | "body"
  | "button"
  | "buttonLong"
  | "buttonSecondary"
  | "buttonSecondaryRedesigned"
  | "buttonSquare"
  | "caption"
  | "captionCaps"
  | "captionSmall"
  | "copyright"
  | "displayBody"
  | "error"
  | "footerHeader"
  | "footerLink"
  | "header"
  | "headerExtraLarge"
  | "headerLarge"
  | "headerSmall"
  | "legal"
  | "navLink"
  | "subheader"
  | "subheaderSmall"

interface OwnProps {
  theme: ThemeProps
  variant?: Variant
}

export type TextProps = ElementProps & OwnProps

function beforeElementStyles({ theme, variant = "body" }: TextProps): CSSProp {
  if (variant.includes("button")) {
    /* :before element is required to adjust for Martel Sans' baseline  */
    /* If font-face is changed, this will likely need to change as well */
    return css`
      &:before {
        content: "";
        height: 0;
        padding-top: ${theme.space.lineHeightOffset};
        display: block;
      }
    `
  }

  return css``
}

function hoverStyles({ theme, variant = "body" }: TextProps): CSSProp {
  if (variant === "footerLink" || variant === "navLink") {
    return css`
      &:hover {
        color: ${theme.colors.textHoverColor[variant]};
      }
    `
  }

  return css``
}

function variantStyles({
  letterSpacing,
  textTransform,
  theme,
  variant = "body",
}: TextProps): CSSProp {
  return css`
    color: ${theme.colors.textColor[variant]};
    font-family: ${theme.fonts.text[variant]};
    font-size: ${theme.fontSizes.text[variant]};
    font-weight: ${theme.fontWeights.text[variant]};
    text-transform: ${textTransform ??
    themeGet(`textTransforms.text.${variant}`, "inherit")};
    letter-spacing: ${letterSpacing
      ? themeGet(
          `letterSpacings.${String(letterSpacing)}`,
          `${String(letterSpacing)}`
        )
      : themeGet(`letterSpacings.text.${variant}`, "inherit")};
  `
}

export const textCss = css`
  ${variantStyles};
  ${beforeElementStyles}
  ${elementCss};
  ${hoverStyles};
`

const Text = styled.div<TextProps>`
  ${textCss};
`
export default Text
